import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import DocsPage from './pages/DocsPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import CookiePolicyPage from './pages/CookiePolicy'
import RegistrationPage from './pages/RegistrationPage'
import AuthPage from './pages/AuthPage'
import AuthCallbackPage from './pages/AuthCallbackPage'
import DashboardPage from './pages/DashboardPage'
import NotFoundPage from './pages/NotFoundPage'
import { AuthProvider } from './hooks/useAuth'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/docs/*' element={<DocsPage />} />
        <Route path='/privacy' element={<PrivacyPolicyPage />} />
        <Route path='/cookie-policy' element={<CookiePolicyPage />} />
        <Route path='/registration' element={<RegistrationPage />} />
        <Route path='/onboarding/complete' element={<RegistrationPage />} />
        <Route path='/auth' element={<AuthPage />} />
        <Route path='/auth/callback' element={<AuthCallbackPage />} />
        <Route path='/dashboard' element={<DashboardPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
